import type { InjectionKey, Component, Ref } from "vue";
import type { InstantGameServiceInterface, InstantGameSessionServiceInterface } from "./types";
import type { GameSessionPageData } from "@/types";


export const InstantGameComponentsKey: InjectionKey<Record<string, Component>> =
  Symbol('InstantGameComponents')

export const InstantGameCheckoutComponentKey: InjectionKey<Component> =
  Symbol('InstantGameCheckoutComponentKey')

export const InstantGameServiceKey: InjectionKey<InstantGameServiceInterface> =
  Symbol('InstantGameServiceKey')

export const InstantGameSessionServiceKey: InjectionKey<InstantGameSessionServiceInterface> =
  Symbol('InstantGameSessionServiceKey')

export const InstantGameSessionCurrentDataKey: InjectionKey<Ref<GameSessionPageData | null>> =
  Symbol('InstantGameSessionCurrentDataKey')
